export enum PaymentMethod {
  WireTransfer = 0,
  TransferenciaBancaria = 1,
  Check = 2,
  Cash = 3,
}

export enum PaymentTerms {
  Net15 = 0,
  Net30 = 1,
  Net60 = 2,
  Net90 = 3,
  Immediate = 4,
}

export enum ShippingMethod {
  Maritimo = 0,
  Aereo = 1,
  Terrestre = 2,
}

export enum ShippingTerms {
  EntregaEnFabrica = 0,
  FOB = 1,
  CIF = 2,
  DDP = 3,
}

export enum PurchaseOrderStatus {
  Draft,
  Submitted,
  Approved,
  Processing,
  PartiallyReceived,
  Received,
  Rejected,
  Cancelled,
}

export enum PurchaseOrderType {
  Standard,
  Yarn,
  Chemicals,
  /** Confidential purchasing (#5942): role-gated, Services items only, follows the Standard flow. */
  Administrative,
}
